<template>
  <div class="flex justify-center mt-16">
    <div class="flex flex-col md:w-1/5 mx-8">
      <div>
        <img :src="logo" alt="">
      </div>
      <div class="mt-4">
        <TextInput ref="email" placeholder="E-Mail Address"></TextInput>
      </div>
      <div class="mt-4">
        <TextInput class="w-full" ref="password" placeholder="Password" :isPassword="true"></TextInput>
      </div>
      <div v-show="message" class="mt-4 text-red">
        <p class="">{{ message }}</p>
      </div>
      <div class="w-1/2 w-full mx-auto mt-4">
        <JButton @click="login" label="Login"></JButton>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

import logo from '@/assets/logo.gif'
import TextInput from '@/components/TextInput'
import JButton from '@/components/JButton'

export default {
  components: { TextInput, JButton },
  data () {
    return {
      logo,
      message: ''
    }
  },
  methods: {
    async login () {
      const email = this.$refs.email.getValue()
      const password = this.$refs.password.getValue()

      firebase.auth().signInWithEmailAndPassword(email, password)
        .then(() => {
          this.$router.replace('/')
        })
        .catch(error => {
          this.error = error
          this.message = 'Invalid username/password'
        })
    }
  }
}
</script>
